import { KYMW1304Model } from '../kymw1304.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * Ｐコード一発選定画面　Ｐコードチェックするサービス
 *
 * @export CheckPCodeService
 * @class CheckPCodeService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CheckPCodeService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1304Model}
   * @memberof CheckPCodeService
   */
  private model: KYMW1304Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof CheckPCodeService
   */
  private vo: {
    pCode: '',
  };

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof CheckPCodeService
   */
  private successFunc: Function;
  /**
   * API例外エラー時後続処理
   *
   * @private
   * @type {Function}
   * @memberof CheckPCodeService
   */
  private exceptionErrorFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CheckPCodeService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.vo.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof CheckPCodeService
   */
  execute(model: any, vo: any, successFunc: Function, exceptionErrorFunc: Function): void {
    this.model = <KYMW1304Model> model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.exceptionErrorFunc = exceptionErrorFunc;
    this.send('checkPCode', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CheckPCodeService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

  /**
   * API例外エラー時の処理
   *
   * @param {string} status 処理結果ステータス
   * @param {*} result レスポンスデータ
   * @memberof CheckPCodeService
   */
  exceptionError(status: string, result: any): void {
    this.exceptionErrorFunc(status, result);
  }
}
